import React, { useEffect } from 'react'
import { Button, Card, Col, Drawer, Form, Icon, notification, Row, Table, Select, Upload, Tabs } from 'antd'
import _ from 'lodash'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL } from '../../request'
import { connect } from 'react-redux'
import moment from 'moment'
const Option = Select.Option

@Form.create()
class UpdateStaffAppraisal extends React.Component {
    state = {
        visible: true,
        loading: false,
        allUsers: [],
        record: {}

    }

    setFormFields = () => {
        let { record } = this.props;
        this.setState({ record })
        setTimeout(() => {
            this.props.form.setFieldsValue({
                userId: record.userId._id,
                appraisalDate: moment(),
                staffSalary: record.staffSalary
            })
        }, 50)
    }

    componentDidMount() {
        this.setState({ allUsers: this.props.allUsers })
        this.setFormFields()
    }


    onClose = () => {
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }


    handleSubmit = e => {
        e.preventDefault();
        const { form, record } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                values._id = record._id
                values.userId = record.userId

                let response = await Request.updateStaffAppraisal(values);
                if (!response.error) {
                    this.onClose()
                    notification.success({
                        message: response.message,
                    })
                } else {
                    notification.error({
                        message: response.message
                    })
                }
            }

        })
    }

    render() {

        const { visible } = this.state
        const { record } = this.props
        const inputTypes = {
            fields: [
                {
                    label: 'Appraisal Type',
                    key: 'appraisalType',
                    type: 'select',
                    required: true,
                    options: ['Performance Appraisal', 'Annual Appraisal'],
                    onChange: v => {
                        this.props.form.setFieldsValue({ appraisalType: v })
                    }
                },
                {
                    label: 'Appraisal Date',
                    key: 'appraisalDate',
                    type: 'date',
                    required: true
                },
                {
                    label: 'Current Salary',
                    key: 'staffSalary',
                    type: 'number',
                    disabled: true
                    // required:true
                },
                {
                    label: 'Appraisal Amount',
                    key: 'appraisalAmount',
                    type: 'number',
                    required: true
                },
                {
                    label: 'Approved By',
                    key: 'approvedBy',
                    type: 'select',
                    required: true,
                    options: ['Naresh Bharti', 'Prem Bharti'],
                    onChange: v => {
                        this.props.form.setFieldsValue({ approvedBy: v })
                    }
                }
            ]
        }

        const {
            form: { getFieldDecorator, }
        } = this.props

        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Update Appraisal:- {this.props.record.userId.name}
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={500}
                visible={visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <div>

                            <GetAllFormFields
                                apiurl={LAPI_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                    <Row>
                        <Col style={{ textAlign: 'center', marginTop: '10px' }}>
                            <h3>Previous Appraisals:- {record.lastAppraisals.length}</h3>
                            <table>
                                <tbody bordered>
                                    <tr>
                                        <th>Appraisal Type</th>
                                        <th>Appraisal Date</th>
                                        <th>Salary After Appraisal</th>
                                    </tr>
                                    {record.lastAppraisals && record.lastAppraisals.map((item) => (
                                        <tr>
                                            <td>{item.lastappraisalType}</td>
                                            <td>{moment(item.lastAppraisalDate).format('DD-MMMM-YYYY')}</td>
                                            <td>{item.salartAfterAppraisal}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UpdateStaffAppraisal)
